var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg19WerbemittelAnalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aAnalog{fill:none;}.bAnalog{fill:#b30200;}.cAnalog{fill:#707070;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aAnalog background-transparent",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bAnalog",
    d: "M571.584,243.261h-42v-22h4v18h34v-18h4Zm0-52h-42v22h4v-18h34v18h4Zm-42,28h4v-4h-4Zm38,0h4v-4h-4Z",
    transform: "translate(-502.584 -177.262)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cAnalog",
    d: "M543.148,184.491h4v68h-4Zm46,0h3.875v68h-3.875Z",
    transform: "translate(-520.148 -170.49)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19WerbemittelAnalog);
export default __webpack_public_path__ + "static/media/19_werbemittel_analog.b058f30291e88dac22ae7ffdef6456c2.svg";
export { ForwardRef as ReactComponent };